import fetchAPI from '../fetchAPI';
import { useQuery, keepPreviousData } from '@tanstack/react-query';

type useZazuAuditLogsProps = {
  startDate?: string | null;
  endDate?: string | null;
  type?: string;
  locationId?: string;
  contactId?: string;
  page: number;
  pageSize: number;
};

export const useZazuAuditLogs = ({
  locationId,
  endDate,
  startDate,
  contactId,
  type,
  page,
  pageSize
}: useZazuAuditLogsProps) => {
  const query = new URLSearchParams();

  if (locationId) query.append('locationId', locationId);
  if (contactId) query.append('contactId', contactId);

  query.append('page', page.toString());
  query.append('pageSize', pageSize.toString());

  if (endDate) query.append('endDate', endDate);
  if (startDate) query.append('startDate', startDate);
  if (type) query.append('type', type);

  return useQuery({
    queryKey: ['ai/audit-trails', locationId, contactId, startDate, endDate, page, pageSize, type],
    queryFn: async () => {
      const response: iResponse<Pagination<ZazuAuditTrail>> = await fetchAPI({
        method: 'GET',
        route: `ai/audit-trails`,
        queryString: query.toString(),
        isZazu: true
      });

      return response;
    },
    enabled: !!startDate && !!endDate, // Query will only run if type is provided
    placeholderData: keepPreviousData
  });
};

export default useZazuAuditLogs;
